import React from "react";
import { Modal, Form, Input, Select, Space } from "antd";

export const BookingStatusFilters = ({
  form,
  isModalOpen,
  handleCancel,
  setFilterForm,
  filterForm,
  handleFilter
}) => {
  return (
    <Modal
      title="Filters"
      open={isModalOpen}
      onOk={handleFilter}
      okText="Filter Data"
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
          <Form.Item name="statusName" className="subscription-plan">
            <Input
              value={filterForm?.statusName}
              onChange={(e) => setFilterForm({ ...filterForm, statusName: e.target.value })}
              size="large"
              placeholder="Filter by Status Name"
            />
          </Form.Item>

          <Form.Item name="status" className="subscription-plan">
            <Select
              value={filterForm?.isActive}
              onChange={(value) => setFilterForm({ ...filterForm, isActive: value })}
              placeholder="Filter by Status"
              style={{ width: "100%" }}
              options={[
                { value: "0", label: "Inactive" },
                { value: "1", label: "Active" },
              ]}
            />
          </Form.Item>
        </div>
        
      </Form>
    </Modal>
  );
};
